import React from "react";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Box,
  Card,
  CardContent,
  CardActions
} from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { formatPrice } from "@/lib/utils";

const SubscriptionPlans = ({ PLANS, handleBuy, buying }: any) => {
  return (
    <Paper elevation={3} sx={{ borderRadius: 3, p: 3 }}>
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, mb: 3, textAlign: "center" }}
      >
        Upgrade Plans
      </Typography>
      <Grid container spacing={3}>
        {PLANS.map((p: any) => (
          <Grid size={{xs : 12, sm : 4}} key={p.code}>
            <Card
              elevation={4}
              sx={{
                borderRadius: 3,
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: 6,
                },
                background: "linear-gradient(135deg, #00b4db, #0083b0)",
                color: "#fff",
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <WorkspacePremiumIcon />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {p.name}
                  </Typography>
                </Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Quota:{" "}
                  <strong>
                    {p.quota === Infinity ? "Unlimited" : p.quota}
                  </strong>
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Price:{" "}
                  <strong>{formatPrice(p.priceInPaise / 100)}</strong>
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: "center", pb: 2 }}>
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: 2,
                    px: 4,
                    py: 1,
                    background: "#fff",
                    color: "#0083b0",
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": { background: "#f1f1f1" },
                  }}
                  onClick={() => handleBuy(p.code)}
                  disabled={buying === p.code}
                >
                  {buying === p.code ? "Processing..." : "Buy Now"}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default SubscriptionPlans;
